"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const mobx_react_1 = require("mobx-react");
const types_1 = require("../../util/types");
exports.default = (0, mobx_react_1.observer)(function UrlChooser(props) {
    const { location, setLocation, label } = props;
    return (react_1.default.createElement(material_1.TextField, { fullWidth: true, variant: "outlined", inputProps: { 'data-testid': 'urlInput' }, defaultValue: location && (0, types_1.isUriLocation)(location) ? location.uri : '', label: label || 'Enter URL', onChange: event => {
            setLocation({
                uri: event.target.value.trim(),
                locationType: 'UriLocation',
            });
        } }));
});
